var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV2RapFireQuestionClock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89.1563,
    height: 89.1563,
    viewBox: "0 0 89.1563 89.1563",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "rapFireClockMask",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.1563 44.5781C89.1563 53.3948 86.5418 62.0136 81.6435 69.3444C76.7452 76.6752 69.783 82.3889 61.6375 85.7629C53.4919 89.137 44.5287 90.0198 35.8814 88.2997C27.2341 86.5796 19.291 82.334 13.0567 76.0996C6.82229 69.8653 2.57663 61.9222 0.856576 53.2749C-0.863481 44.6276 0.0193151 35.6644 3.39333 27.5188C6.76734 19.3732 12.481 12.4111 19.8119 7.51277C27.1427 2.61446 35.7614 0 44.5781 0L44.5781 44.5781L89.1563 44.5781Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.1563 44.5781C89.1563 53.3948 86.5418 62.0136 81.6435 69.3444C76.7452 76.6752 69.783 82.3889 61.6375 85.7629C53.4919 89.137 44.5287 90.0198 35.8814 88.2997C27.2341 86.5796 19.291 82.334 13.0567 76.0996C6.82229 69.8653 2.57663 61.9222 0.856576 53.2749C-0.863481 44.6276 0.0193151 35.6644 3.39333 27.5188C6.76734 19.3732 12.481 12.4111 19.8119 7.51277C27.1427 2.61446 35.7614 0 44.5781 0L44.5781 44.5781L89.1563 44.5781Z",
    stroke: "#FF00F2",
    strokeWidth: 20,
    mask: "url(#rapFireClockMask)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2RapFireQuestionClock);
export default __webpack_public_path__ + "static/media/v2_rap_fire_question_clock.9522f22550c20a504ab4cc017b44e2da.svg";
export { ForwardRef as ReactComponent };